import { type QueryClient } from '@tanstack/vue-query';

import { keys } from '../../keys';

export const handleCurrentUserInvitationSuccess
  = (queryClient: QueryClient) => () => queryClient
    .invalidateQueries({ queryKey: keys.invitations.currentUserInvitations.queryKey });
